<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dJ18tE/tc-custom/9780813178202.jpg?1726444214938" alt="This image is the cover for the book Myth of Triumphalism"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Myth of Triumphalism
      </h1>
      <p class="bookDescription body article font2">
        <b>This historical study dismantles the myth of Reagan’s hardline victory and sheds light on his true diplomatic success in cooperation with Gorbachev.</b><br/><br/>Did President Reagan’s hawkish policies destroy the Soviet Union and enable the United States to win the Cold War? Many Americans believe this to be the case. In this view?known as “triumphalism”?Reagan’s denunciations of the “evil empire” and his military buildup compelled Moscow to admit defeat. The president’s triumph demonstrates that America’s leaders should stand strong and threaten adversaries into submission.<br/><br/>Drawing on both US and Soviet sources, this study demonstrates that triumphalism is based on a series of falsehoods about President Reagan’s intentions, his policies, and the impact his administration had on the Soviet Union. In reality, the president’s initially hardline posture undermined US interests and brought the superpowers to the brink of war. Success only came when Reagan changed his approach to one of cooperation.<br/><br/>Together, President Reagan and General Secretary Gorbachev were able to accomplish what no one at the time thought possible?the peaceful conclusion of the Cold War. The president’s opposition to nuclear weapons, his determined leadership, and his dedication to diplomacy are his most enduring legacies.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beth A. Fischer
      </h2>
      
      <p class="authorDescription body article">Beth A. Fischer is an associate professor and the director of the Woodsworth One program at the University of Toronto. She specializes in international security and American foreign policy and has written extensively about President Reagan and the Cold War. A Nobel Fellow, Fischer is the author of The Reagan Reversal: Foreign Policy and the End of the Cold War.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7a1350fb